import { useState, useEffect } from 'react';
import { Icon } from './Icon';

export const ScrollToTop = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const toggleVisibility = () => {
            if (window.scrollY > 300) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        window.addEventListener('scroll', toggleVisibility);
        return () => window.removeEventListener('scroll', toggleVisibility);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    if (!isVisible) {
        return null;
    }

    return (
        <button
            onClick={scrollToTop}
            className="fixed bottom-8 right-8 w-12 h-12 bg-gray-900 text-white rounded-full shadow-xl hover:bg-gray-800 z-50 flex items-center justify-center transition-all duration-300 hover:scale-110"
            aria-label="Scroll to top"
        >
            <Icon name="arrow-right" className="w-5 h-5 -rotate-90" />
        </button>
    );
};
